<template>
  <div class="paymoney relative">
    <div class="top flex aCenter jBetween">
      <img src="~assets/img/tlogo.png" alt="" />
      <div class="flex aCenter">
        <!-- <div class="QQ">{{ $store.state.userinfo.email }}</div> -->
        <div class="QQ">{{ $store.state.userinfo.group_name }}</div>
        <div class="outlogin" @click="outlogin">退出登录</div>
      </div>
    </div>
    <div class="buy">
      <div class="title flex aCenter jBetween">
        <i class="icon-left el-icon-arrow-left" @click="goback"></i>
        <span>支付中心</span>
        <div></div>
      </div>
      <!-- <div class="money-box column aCenter jCenter">
        <div class="yfje">应付金额</div>
        <div class="money">
          <span class="icon">￥</span>
          {{
            (
              parseFloat($route.query.money * 0.01) +
              parseFloat($route.query.money) * $route.query.huilv
            ).toFixed(2)
          }}
        </div>
      </div> -->
      <div class="flex">
        <div class="czts column aCenter padding-lr">
          <div class="s-box flex">
            <div class="s-box-item">商品价格：</div>
            <div class="s-box-item">${{ $route.query.money }}</div>
          </div>
          <div class="s-box flex aCenter">
            <div class="s-box-item">应付金额：</div>
            <div class="s-box-item2 money-box flex aCenter">
              $
              {{
                (
                  parseFloat($route.query.money * 0.01) +
                  parseFloat($route.query.money)
                ).toFixed(2)
              }}
            </div>
            <div class="mle flex">
              <div class="black-18-400">折合人民币：</div>
              <div class="s-box-item2">
                ￥{{
                  (
                    parseFloat($route.query.money * 0.01) +
                    parseFloat($route.query.money) * $route.query.huilv
                  ).toFixed(2)
                }}
              </div>
            </div>
          </div>

          <div class="s-box-item3">
            手续费： ${{ ($route.query.money * 0.01).toFixed(2) }}
          </div>

          <div class="s-box-item3">
            当前汇率：1USD={{ $route.query.huilv }}CNY
          </div>
          <div class="chose">请选择支付方式</div>
          <img class="line" src="../../assets/img/line.png" alt="" />
          <div class="box flex aCenter jBetween">
            <div class="box-item">
              <!-- <div class="box-item-bor column aCenter jAround">
            <div class="yue">余额(元)</div>
            <div class="should-pay">{{ this.$route.query.yue }}</div>
            <div class="btn" @click="paypage = true">立即支付</div>
          </div>
          <div class="pay-text">余额支付</div> -->
              <div class="s-box flex aCenter relative">
                <div class="s-box-item">余额支付：</div>
                <img
                  class="cur"
                  v-if="yezf"
                  @click="yuezf"
                  src="../../assets/img/icon_zhifu_selected.png"
                  alt=""
                />
                <img
                  class="cur"
                  v-else
                  @click="yuezf"
                  src="../../assets/img/icon_zhifu_normal.png"
                  alt=""
                />
                <div
                  class="choose-text absolute"
                  :class="{ activecolor: yezf }"
                  @click="yuezf"
                >
                  立即支付
                </div>
              </div>
              <div class="s-box flex aCenter relative">
                <div class="s-box-item">支付宝支付：</div>
                <img
                  class="cur"
                  v-if="ewmzf"
                  @click="saoma(2)"
                  src="../../assets/img/icon_zhifu_selected.png"
                  alt=""
                />
                <img
                  class="cur"
                  v-else
                  @click="saoma(2)"
                  src="../../assets/img/icon_zhifu_normal.png"
                  alt=""
                />
                <div
                  class="choose-text1 absolute cur"
                  :class="{ activecolor: ewmzf }"
                  @click="saoma(2)"
                >
                  二维码支付
                </div>
              </div>
              <div class="s-box flex aCenter relative">
                <div class="s-box-item">银联支付：</div>
                <img
                  class="cur"
                  @click="saoma(3)"
                  v-if="ylzf"
                  src="../../assets/img/icon_zhifu_selected.png"
                  alt=""
                />
                <img
                  class="cur"
                  @click="saoma(3)"
                  v-else
                  src="../../assets/img/icon_zhifu_normal.png"
                  alt=""
                />
                <div
                  class="choose-text absolute"
                  :class="{ activecolor: ylzf }"
                  @click="saoma(3)"
                >
                  立即支付
                </div>
              </div>
            </div>
            <!-- 右面二维码 -->
            <div class="box-item" v-if="saomab">
              <div class="box-item-bor column aCenter jAround">
                <img class="img" :src="saomaimg" alt="正在努力加载中。。。" />
                <!-- <div class="column aCenter jAround" style="height: 100%" v-else>
              <div class="chose-btn" @click="saoma(2)">支付宝扫码</div>
              <div class="chose-btn" @click="saoma(3)">银联支付</div>
            </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="czbg column aCenter padding-lr">
          <div class="flex">
            <img src="../../assets/img/icon_tip.png" alt="" />
            <div class="black-18-400">充值小提示</div>
          </div>
          <div class="gtm gray-16-400" v-html="paytip"></div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div v-show="paypage" class="absolute pop-box">
      <div class="zhezhao column aCenter jCenter">
        <div class="paypage-box column aCenter jAround" v-show="!succ">
          <img src="../../assets/img/icon_yuezhifu.png" alt="" />
          <img src="../../assets/img/line.png" alt="" />
          <div class="zfye-text">支付余额</div>
          <el-input
            style="width: 420px"
            type="password"
            v-model="pass"
            placeholder="请输入登录密码"
          ></el-input>
          <div class="li-btn" @click="buy">确认支付</div>
        </div>

        <div class="paypage-box column aCenter jCenter" v-show="succ">
          <img src="../../assets/img/icon_zhifu_cg.png" alt="" />
          <div class="zfye-text">恭喜您，支付成功！</div>
        </div>

        <img
          @click="paypage = false"
          class="icon-close"
          src="../../assets/img/pop_ico_closed.png"
          alt=""
        />
      </div>
    </div>
    <form
      v-show="false"
      ref="form"
      :action="http_url"
      method="post"
      target="_blank"
    >
      <input
        v-for="(value, name, index) in pay_params"
        :key="index"
        type="text"
        :name="name"
        :value="value"
      />
      <input type="submit" value="submit" />
    </form>
  </div>
</template>

<script>
import Index from "./Index";
import { getTipApi } from "../../network/api";
export default {
  name: "Paymoney",
  mixins: [Index],
  created() {
    getTipApi()
      .then((res) => {
        console.log(res);
        this.paytip = res.data.data.data;
      })
      .catch();
  },
};
</script>
<style scoped src="./Paymoney.css"></style>
